import api from 'src/api'
import swal from 'sweetalert2'

export default (data) => swal.fire({
  title: 'Labels drucken',
  input: 'radio',
  inputOptions: {
    0: 'EK Verbergen',
    1: 'EK Anzeigen'
  },
  inputValue: 0,
  confirmButtonText: 'Jetzt Drucken',
  showCancelButton: true,
  cancelButtonText: 'Nein danke',
  buttonsStyling: false,
  confirmButtonClass: 'btn btn-lg btn-fill btn-info',
  cancelButtonClass: 'btn btn-lg btn-fill btn-default'
}).then((result) => {
  if (result.isConfirmed) {
    const productIds = data.map(({ id }) => id)
    const products = encodeURIComponent(JSON.stringify(productIds))
    const url = `${api}/test_labels?show_ek=${result.value}&products=${products}`
    window.open(url)
  }
})
